module.exports = __webpack_public_path__ + "img/c00_buildingtechplacermining_Normal_ua.b17187c8.webp";